import React from 'react'

import Base from '../_Base'

const Checkmark20 = (props) => (
  <Base width="20" height="20" viewBox="0 0 20 20" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.2072 6.70712L9.20718 13.7071L8.50008 14.4142L7.79297 13.7071L4.79297 10.7071L6.20718 9.29291L8.50008 11.5858L14.793 5.29291L16.2072 6.70712Z"
    />
  </Base>
)

export default Checkmark20
